export default function generateTestId(string) {
  return string
    .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
}
